import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: {
    base,
    scheme,
    chart: { primary },
  },
}: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme = numberOfColors === 0 ? [primary] : scheme;

  return (
    <svg width="100%" height="100%" viewBox="0 0 440 120">
      <rect
        fill={_scheme[3] || _scheme[1] || base}
        x="0"
        y="0"
        width="222"
        height="120"
      />
      <rect fill={_scheme[0]} x="224" y="0" width="216" height="51" />
      <rect
        fill={_scheme[2] ? _scheme[1] : _scheme[0]}
        x="224"
        y="53"
        width="159"
        height="67"
      />
      <rect
        fill={_scheme[2] || _scheme[1] || base}
        x="385"
        y="53"
        width="55"
        height="67"
      />
    </svg>
  );
};
